var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.0123 46.1916C100.663 48.7945 100.662 53.0151 98.0123 55.6188L54.8006 98.0474C52.149 100.651 47.851 100.651 45.1994 98.0474L1.98767 55.6188C-0.661883 53.0151 -0.663225 48.7945 1.98767 46.1916C4.63856 43.5888 8.93708 43.5901 11.5888 46.1916L43.2102 77.24L43.2102 6.6667C43.2102 2.98478 46.2501 -2.34952e-06 50 -2.18561e-06C53.7499 -2.02169e-06 56.7898 2.98478 56.7898 6.6667L56.7898 77.24L88.4112 46.1916C91.0629 43.5901 95.3614 43.5888 98.0123 46.1916Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.d3a3a8d7476a926cf87e9cc843f7a82b.svg";
export { ForwardRef as ReactComponent };